import React from 'react';
import { Row } from '../../../../atoms/row/Row';
import { Typography } from '../../../../atoms/typography/Typography';
import { Controller, useFormContext } from 'react-hook-form';
import { Stack } from '../../../../atoms/stack/Stack';
import { Radio } from '../../../../atoms/radio/Radio';

const DoubleRadioQuestion = ({ answers, questionId }) => {
  const { watch, control } = useFormContext();
  const current = watch(`question-${questionId}`);

  const customOnChange = (onChange, answer, value) => {
    if (current && current.find((el) => el.title === answer)) {
      let newValue = current.map((el) => {
        if (el.title === answer) {
          el.value = value;
        }
        return el;
      });
      onChange(newValue);
    } else {
      let newObj = { title: answer, value: value };
      let newValue = current ? [...current, newObj] : [newObj];
      onChange(newValue);
    }
  };

  return (
    <Stack className={'gap-3'}>
      <Controller
        control={control}
        name={`question-${questionId}`}
        render={({ field }) =>
          answers.map((answer, index) => {
            const currentValue = current?.find((el) => el.title === answer);
            return (
              <Stack
                key={index}
                className={`w-full py-3 pl-4 pr-6 bg-[#EAF5FB] rounded-3xl gap-3`}
              >
                <Typography
                  fontVariant={'md'}
                  textAlign={'left'}
                  className={'text-customGray-700 font-normal'}
                >
                  {answer}
                </Typography>
                <Row className={'gap-3'}>
                  <Row className={'gap-2 items-center'}>
                    <Radio
                      name={`question-${questionId}-${index}`}
                      value="Krav"
                      checked={
                        currentValue ? currentValue.value === 'Krav' : false
                      }
                      onChange={() =>
                        customOnChange(field.onChange, answer, 'Krav')
                      }
                    />
                    <Typography fontVariant={'sm'} textAlign={'left'}>
                      Krav
                    </Typography>
                  </Row>
                  <Row className={'gap-2 items-center'}>
                    <Radio
                      name={`question-${questionId}-${index}`}
                      value="Spelar ingen roll"
                      checked={
                        currentValue
                          ? currentValue.value === 'Spelar ingen roll'
                          : false
                      }
                      onChange={() =>
                        customOnChange(
                          field.onChange,
                          answer,
                          'Spelar ingen roll'
                        )
                      }
                    />
                    <Typography fontVariant={'sm'} textAlign={'left'}>
                      Spelar ingen roll
                    </Typography>
                  </Row>
                </Row>
              </Stack>
            );
          })
        }
      />
    </Stack>
  );
};

export default DoubleRadioQuestion;
